import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Link } from '@xingternal/link';

import styles from './LegalFooter.css';

const LegalFooter = ({
  intl: { formatMessage },
  links,
  responsive,
  vertical,
  isInlineAlways,
  withCopyright,
}) => (
  <nav
    className={classNames(styles.nav, {
      [styles.responsive]: responsive,
      [styles.vertical]: vertical,
      [styles.isInlineAlways]: isInlineAlways,
    })}
  >
    {links.map((link) => (
      <Link className={styles.link} key={link.key} to={link.href}>
        {formatMessage({ id: link.title })}
      </Link>
    ))}
    {withCopyright && (
      <span className={styles.copyright}> | &copy; New Work SE</span>
    )}
  </nav>
);

LegalFooter.propTypes = {
  intl: PropTypes.object.isRequired,
  responsive: PropTypes.bool,
  isInlineAlways: PropTypes.bool,
  vertical: PropTypes.bool,
  withCopyright: PropTypes.bool,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
    })
  ).isRequired,
};
LegalFooter.defaultProps = {
  responsive: false,
  vertical: false,
  isInlineAlways: false,
  withCopyright: false,
};

export { LegalFooter };
